import { USA } from './countries';

export const DETECTED_COUNTRY_HEADER = 'X-OL-Detected-Country';

export const USER_COUNTRY_HEADER = 'X-OL-User-Country';

export const UNKNOWN_COUNTRY = 'XX';

export const COUNTRY_CODE_PATTERN = /^[A-Z]{2}$/;

export const US_COUNTRY = USA.two_digit_code;

export const SELECT_COUNTRY_LABEL = 'Select country';

export const SUPPORT_EMAIL = 'support@imprintengine.com';

export const COUNTRY_STORAGE_PREFIX = 'claim';
export const COUNTRY_STORAGE_KEYS = {
  userCountry: 'userCountry',
  hintDismissed: 'countryHintDismissed',
} as const;

export const MARKETPLACE_REMOVED_NOTICE = 'Marketplace items removed — they ship to US addresses only.';

export const getMarketplacePicksRemovedNotice = (count: number) =>
  count === 1
    ? 'Your marketplace pick was removed — they ship to US addresses only.'
    : 'Your marketplace picks were removed — they ship to US addresses only.';

export const US_ONLY_TITLE_FALLBACK = 'Something is waiting for you';
export const getUsOnlyTitle = (companyName?: string) =>
  companyName ? `${companyName} has something for you` : US_ONLY_TITLE_FALLBACK;
export const US_ONLY_SUBTITLE = 'Delivery to US addresses only';
export const US_ONLY_UNKNOWN_LOCATION_TEXT = 'We couldn’t detect your location';
export const US_ONLY_DETECTED_LEAD = 'Showing this because your connection looks like';
export const US_ONLY_CHOSEN_LEAD = 'Showing this because you chose';
export const HAVE_US_ADDRESS_TITLE = 'Have a US address?';
export const HAVE_US_ADDRESS_BODY =
  'Any home, work, or friend’s address in the US works — you’ll enter it after you pick your items';
export const CONTINUE_WITH_US_ADDRESS_LABEL = 'Continue with a US address';
export const NEED_HELP_TEXT = 'Need help?';
export const CONTACT_SUPPORT_LABEL = 'Contact support';

export const SHIPPING_TO_LABEL = 'Shipping to';
export const CHANGING_COUNTRY_LABEL = 'Changing country';
export const SHIPPING_TO_VALUE_HEIGHT = 32;
export const SHIPPING_TO_SPINNER_SIZE = 18;
export const SHIPPING_TO_CARET_SIZE = 24;
export const SHIPPING_TO_MENU_ROW_HEIGHT = 36;
export const SHIPPING_TO_MENU_MAX_HEIGHT = 360;
export const SHIPPING_TO_CARD_MIN_HEIGHT = 48;
export const SHIPPING_COUNTRY_SHEET_TITLE = 'Where should we ship?';
export const SHIPPING_COUNTRY_SHEET_LABEL = 'Shipping country';
export const SHIPPING_TO_SHEET_ROW_HEIGHT = 48;
export const SHIPPING_TO_SHEET_MAX_HEIGHT_PERCENT = 80;
export const NOTICE_SNACKBAR_TOP_OFFSET = 8;

export const COUNTRY_HINT_US_TITLE = 'Showing items that ship to the United States.';
export const COUNTRY_HINT_US_BODY = 'Somewhere else? Change the country so we only show what can reach you.';
export const getCountryHintTitle = (countryName: string) => `Showing items that ship to ${countryName}.`;
export const COUNTRY_HINT_NON_US_BODY = 'Marketplace items aren’t included — they ship to US addresses only.';
export const COUNTRY_HINT_UNKNOWN_TITLE = 'We couldn’t detect your location.';
export const COUNTRY_HINT_UNKNOWN_BODY =
  'Some gifts ship to US addresses only. Select your country to see everything that can reach you.';
export const COUNTRY_HINT_CHANGE_LABEL = 'Change';
export const COUNTRY_HINT_GOT_IT_LABEL = 'Got it';
export const COUNTRY_HINT_DELAY_MS = 300;
export const COUNTRY_HINT_TRANSITION = { enter: 200, exit: 150 };
export const COUNTRY_HINT_WIDTH = 360;
export const COUNTRY_HINT_VIEWPORT_GUTTER = 48;
export const COUNTRY_HINT_OFFSET = 12;
export const COUNTRY_HINT_ARROW_SIZE = 12;
export const COUNTRY_HINT_ARROW_MIN_RIGHT = 16;
